import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { SitePage } from "@/components/landing/SitePage";

export default function LandingPage({ content: previewContent, preview = false, pageId, onSelect }) {
  const [content, setContent] = useState(previewContent || null);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (previewContent) { setContent(previewContent); return; }
    let active = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-content`, { cache: "no-store" })
      .then((res) => { if (!res.ok) throw new Error(); return res.json(); })
      .then((data) => { if (active) setContent(data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [previewContent]);
  if (!content?.layout) return <div className="min-h-screen flex flex-col items-center justify-center gap-5" data-testid="site-content-loading">{error ? <><p data-testid="site-content-error">The page could not load.</p><button data-testid="site-content-retry" onClick={() => window.location.reload()}>Try again</button></> : <Loader2 className="w-8 h-8 animate-spin text-electric" />}</div>;
  return <SitePage content={content} preview={preview} pageId={pageId} onSelect={onSelect} />;
}